import { createFileRoute } from "@tanstack/react-router";

import { YourContextSettingsPanel } from "../components/settings/YourContextSettings";

function SettingsYourContextRoute() {
  return <YourContextSettingsPanel />;
}

export const Route = createFileRoute("/settings/your-context")({
  component: SettingsYourContextRoute,
});
